import { postMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const ADD_COUPON = 'ADD_COUPON';
export const ADD_COUPON_SUCCESS = 'ADD_COUPON_SUCCESS';
export const ADD_COUPON_FAILURE = 'ADD_COUPON_FAILURE';

// Action Creators
export const fetchAddCoupon = () => ({
  type: ADD_COUPON,
});

export const fetchAddCouponSuccess = (data) => ({
  type: ADD_COUPON_SUCCESS,
  payload: data,
});

export const fetchAddCouponFailure = (error) => ({
  type: ADD_COUPON_FAILURE,
  payload: error,
});

// Thunk Function
export const addCouponCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchAddCoupon(data, external));
    try {
      const response = await postMethodWithToken(url.addCouponSuperAdmin, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchAddCouponSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchAddCouponFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchAddCouponFailure(error.message));
    }
  };
};
